import { FaRegFilePdf } from "react-icons/fa6";
import { FaLinkedinIn } from 'react-icons/fa'

import Pdf from "./cv_01_enUS.pdf";
const onResumeClick = () => {
  window.open(Pdf);
}

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <div>
        <a onClick={onResumeClick} ><FaRegFilePdf /></a>
      </div>
      <div>
        <a href="https://www.linkedin.com/in/andrepimentelc/"><FaLinkedinIn /></a>
      </div>
    </div>
  )
}

export default SocialMedia